<template>
	<v-card :dark="darkElevator" class="elevator elevation-5" height="" width="30">
		<v-layout column align-center>
			<v-flex ><v-btn depressed icon @click="floorUp"><v-icon>expand_less</v-icon></v-btn></v-flex>
			<v-flex >{{currentFloor}}</v-flex>
			<v-flex ><v-btn depressed icon @click="floorDown"><v-icon>expand_more</v-icon></v-btn></v-flex>
		</v-layout>
	</v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
data () {
	return {}
},

computed: {
	...mapState({   	currentFloor: state => state.mapFunctions.currentFloor,
						floors: state => state.mapFunctions.floors,
						darkElevator: state => state.ui.darkElevator,
				})
},

methods : {
	...mapActions([ 	'setCurrentFloor',
					]),

	floorUp() {
		console.log("Floor Up")
		let floorIndex = this.floors.indexOf(this.currentFloor)
		floorIndex++
		let newFloor = this.floors[floorIndex]
		newFloor && this.setCurrentFloor(newFloor)
	},

	floorDown() {
		console.log("Floor Up")
		let floorIndex = this.floors.indexOf(this.currentFloor)
		floorIndex--
		let newFloor = this.floors[floorIndex]
		newFloor && this.setCurrentFloor(newFloor)
	},
},
}

</script>

<style>
.elevator {
	position: absolute;
	top: 120px;
	right:  20px;
	z-index: 100;
	border-color: #00000080 !important;
	border-style: solid;
	border-width: 1px;

}
</style>
